<template>
  <div>
    <div>Onay Bekleyen Marka</div>
    <div>
      Bu markaya ait ürünler için marka talebiniz alınmıştır. Markanız onaylandıktan sonra ürün onay süreciniz başlayacaktır.
    </div>
  </div>
</template>

<script>
export default {
  name: 'PassiveBrand',
};
</script>
